import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";

const getAllNews = createAsyncThunk("news/getAll", async ({ page, main }) => {
  const { request } = useHttp();
  return await request({
    url: `/press_center/news/${main ? `?main=${main}` : ""}${
      page ? `?page=${page}` : ""
    }`,
  });
});

const getActualVideo = createAsyncThunk("news/getActualVideo", async () => {
  const { request } = useHttp();
  return await request({
    url: `/press_center/actual_video/`,
  });
});

const getSingleNews = createAsyncThunk("news/getSingle", async (id) => {
  const { request } = useHttp();
  return await request({
    url: `/press_center/news/${id}/`,
  });
});

const getGallery = createAsyncThunk("gallery/get", async ({ page = 1 }) => {
  const { request } = useHttp();
  return await request({
    url: `/press_center/gallery/?page=${page}`,
  });
});

export { getAllNews, getSingleNews, getGallery, getActualVideo };
